import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const RequireAddress = ({ children }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (loading) return;
    
    const allowedPaths = ['/login', '/add-address'];
    if (allowedPaths.includes(location.pathname)) return;
    
    // Only redirect when addresses are known to be empty (undefined = not loaded yet)
    if (user && Array.isArray(user.addresses) && user.addresses.length === 0) {
      navigate('/add-address', { state: { from: location.pathname } });
    }
  }, [user, loading, navigate, location]);

  if (loading) return null; // or a spinner

  // If user has addresses or isn't logged in (App handles auth requirement), render children
  return children;
};

export default RequireAddress;
